const names = {
    AnswersChanged: "QUESTION.ANSWERSCHANGED",
    UpdateStarted: "QUESTION.UPDATESTARTED",
    UpdateErrored: "QUESTION.UPDATEERRORED",
    UpdateSucceeded: "QUESTION.UPDATESUCCEEDED"
};

const expectedQuestionPathLength = 6;

// Checks whether the specified path has the expected length.  If it does not,
// throws an exception.
function checkQuestionIDPath(path) {
    if ((path || []).length !== expectedQuestionPathLength) {
        throw `Question ID paths should have 5 segments; this does not: ${path}`;
    }
}

const questionChangeEvents = {
    AnswersChanged: {
        Name: names.AnswersChanged,
        New(questionIDPath, answerSelections, additionalComment, Task) {
            // Validate the arguments
            checkQuestionIDPath(questionIDPath);

            // Return a plain old JS object with a type property
            return {
                type: names.AnswersChanged,
                QuestionIDPath: questionIDPath,
                AnswerSelections: answerSelections,
                AdditionalComment: additionalComment,
                Task: Task
            };
        }
    },
    UpdateStarted: {
        Name: names.UpdateStarted,
        New(questionIDPath, answerSelections, additionalComment) {
            checkQuestionIDPath(questionIDPath);

            return {
                type: names.UpdateStarted,
                QuestionIDPath: questionIDPath,
                AnswerSelections: answerSelections,
                AdditionalComment: additionalComment
            };
        }
    },
    UpdateErrored: {
        Name: names.UpdateErrored,
        New(questionIDPath, answerSelections, additionalComment, error) {
            checkQuestionIDPath(questionIDPath);

            return {
                type: names.UpdateErrored,
                QuestionIDPath: questionIDPath,
                Error: error,
                AnswerSelections: answerSelections,
                AdditionalComment: additionalComment
            };
        }
    },
    UpdateSucceeded: {
        Name: names.UpdateSucceeded,
        New(questionIDPath, answerSelections, additionalComment) {
            checkQuestionIDPath(questionIDPath);

            return {
                type: names.UpdateSucceeded,
                QuestionIDPath: questionIDPath,
                AnswerSelections: answerSelections,
                AdditionalComment: additionalComment
            };
        }
    }
};

module.exports = questionChangeEvents;


// WEBPACK FOOTER //
// ./src/events/questionChange/questionChangeEvents.js